import "./Cookies.css";

const Cookies = () => {
    return (
      <div className="Cookies">
        <h1>COOKIES</h1>
        <p className="spacingP">This page is dedicated to my loving Grandmother ❤️ whose favourite food,</p>
        <p className="spacingP">morning, day, and night, is (you guessed it) <span id="cookies-text">COOKIES!</span></p>
        <p></p>
      </div>
    );
}

export default Cookies;